<template>
    <canvas
        ref="confettiCanvas"
        style="
            position: fixed;
            top: 3%;
            left: 3%;
            pointer-events: none;
            z-index: 99999;
        "
        width="1672"
        height="975"
    ></canvas>
</template>
<script>
import confetti from "canvas-confetti";

export default {
    props: {
        fireConfetti: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        firing: false,
        count: 200,
        defaults: {
            origin: { y: 0.7 },
            resize: true,
        },
        confettiCannon: null,
    }),
    watch: {
        fireConfetti(val) {
            if (val) {
                this.fireCannon();
            }
        },
    },
    methods: {
        fire(particleRatio, opts) {
            this.confettiCannon(
                Object.assign({}, this.defaults, opts, {
                    particleCount: Math.floor(this.count * particleRatio),
                })
            );
        },
        fireCannon() {
            this.fire(0.25, {
                spread: 26,
                startVelocity: 55,
            });
            this.fire(0.2, {
                spread: 60,
            });
            this.fire(0.35, {
                spread: 100,
                decay: 0.91,
                scalar: 0.8,
            });
            this.fire(0.1, {
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
                scalar: 1.2,
            });
            this.fire(0.1, {
                spread: 120,
                startVelocity: 45,
            });
        },
    },
    mounted() {
        this.confettiCannon = confetti.create(this.$refs.confettiCanvas, {
            resize: true,
        });
        
        // Check if we should fire confetti on mount
        if (this.fireConfetti) {
            console.log('Firing confetti on mount');
            this.fireCannon();
        }
    },
};
</script>
